import { css } from "styled-components";

import { Color, translucentBlack } from "~/Color";

export type Shadow = {
  readonly inset?: boolean;
  readonly color?: string;
  readonly size: number;
};

export const color = (): Color => translucentBlack(0.12);
export const large = (): Shadow => ({ size: 0.3 });
export const medium = (): Shadow => ({ size: large().size / 2 });
export const small = (): Shadow => ({ size: medium().size / 2 });

export const offThePage = (): Shadow => ({
  size: large().size * 3,
  color: translucentBlack(0.24),
});

export const overAnImage = (): Shadow => ({
  size: large().size * 5,
  color: translucentBlack(0.5),
});

export namespace Box {
  export const styles = (shadow: Shadow) => css`
    box-shadow: ${style(shadow)};
  `;

  export const style = ({
    inset,
    size,
    color: customColor = color(),
  }: Shadow) =>
    `${inset ? "inset " : ""}0 ${size}em ${size * 3}em 0 ${customColor}`;
}
